/**
 * ShowcaseGallery — recent admin-curated grading reports. Each item links
 * to its public share page so visitors can see the full report.
 */
import React, { useEffect, useState } from 'react';

export default function ShowcaseGallery({ limit = 6 }) {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch(`/api/grading/showcase?limit=${limit}`)
      .then(r => r.json())
      .then(data => { if (alive) setItems(Array.isArray(data?.items) ? data.items : []); })
      .catch(e => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, [limit]);

  if (error || !items.length) {
    return null; // hide the section entirely until admins have curated samples
  }

  return (
    <section className="gp-section">
      <span className="gp-eyebrow">Real reports</span>
      <h2 className="gp-h2">Cards we've graded</h2>
      <p className="gp-body">Click any card to see the full grading report.</p>
      <div className="gp-showcase">
        {items.map(item => (
          <a key={item.id}
             className="gp-showcase__item"
             href={`/grade/share/${encodeURIComponent(item.share_token)}`}>
            <div className="gp-showcase__img">
              {item.front_image_url
                ? <img src={item.front_image_url} alt={item.card_name || 'graded card'} loading="lazy" />
                : <div style={{ height: '100%' }} />}
              {item.grade_overall != null && (
                <div className="gp-showcase__grade">
                  {Number(item.grade_overall).toFixed(1).replace(/\.0$/, '')}
                </div>
              )}
            </div>
            <div className="gp-showcase__body">
              <p className="gp-showcase__name">{item.card_name || 'Unidentified card'}</p>
              {item.showcase_caption && <p className="gp-showcase__caption">{item.showcase_caption}</p>}
              <div className="gp-showcase__subs">
                <SubChip label="Cnt" value={item.grade_centering} />
                <SubChip label="Cor" value={item.grade_corners} />
                <SubChip label="Edg" value={item.grade_edges} />
                <SubChip label="Sur" value={item.grade_surface} />
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

function SubChip({ label, value }) {
  return (
    <div className="gp-showcase__sub">
      <strong>{value != null ? Number(value).toFixed(0) : '—'}</strong>
      {label}
    </div>
  );
}
